import { env } from '@/lib/env'

/**
 * Base URL of the TQS BFF proxy (`{backend}/api/v1/tqs`), normalized and
 * https-defaulted. All TQS requests go through the BFF proxy.
 */
export function getTqsProxyBase(): string {
  const backendUrl = env.backendApiUrl.replace(/\/+$/, '')
  const withProtocol = backendUrl.startsWith('http://') || backendUrl.startsWith('https://')
    ? backendUrl
    : `https://${backendUrl}`
  return `${withProtocol}/api/v1/tqs`
}
